import { render, staticRenderFns } from "./PresentCourseManageView.vue?vue&type=template&id=0f3cd9b2&scoped=true"
import script from "./PresentCourseManageView.vue?vue&type=script&lang=js"
export * from "./PresentCourseManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3cd9b2",
  null
  
)

export default component.exports